/**
 * Das Mikro wartet auf den Schmied. (15.10.2026, shared/schmied.ts)
 *
 * Spricht Vespera am Ende ihrer Antwort den Schmied an („Schmied, du bist dran.“), geht das Auto-Mikro NICHT sofort auf,
 * sondern erst
 *   a) wenn ein Beitrag des Schmieds kam — und, wenn „Entwickler vorlesen“ an ist, fertig vorgelesen ist, oder
 *   b) nach SCHMIED_WARTEN_MS ohne Beitrag (Rückfall, damit Martin nicht festhängt).
 *
 * EIN Besitzer für dieses Warten: höchstens EIN offenes Warten; ein neues ersetzt das alte, `abbrechen` beendet es ohne
 * Öffnen (neue Entscheidung, neuer Zug). `oeffne` wird höchstens einmal gerufen. Die Uhr kommt von außen (Tests stellen sie).
 *
 * ⚠️⚠️ 15.10.2026, 22:37 (Martin: „Mikro geht nicht auf“) — DER BEITRAG KAM VOR DEM WARTEN.
 *    Journal: `[dreier] beitrag` um 22:36:57, Vesperas Vorlese-Ende (und damit `beginne`) erst um 22:37:04 — der Schmied
 *    liest Vesperas TEXT mit und antwortet, während ihre Stimme noch spricht. `beitragKam` fand kein Warten und vergaß den
 *    Beitrag; `beginne` setzte danach „liest vor“ zurück, also überging auch `vorgelesen` (22:37:18) das Ende — geöffnet hat
 *    erst die Frist (22:37:24). Darum jetzt:
 *      - das Vorlesen wird UNABHÄNGIG vom Warten gezählt (`vorlesenOffen`: jeder vorgelesene Beitrag ruft genau einmal
 *        `vorgelesen`), `abbrechen`/`beginne` setzen den Zähler nie zurück;
 *      - ein Beitrag ohne Warten wird mit seinem Zug vorgemerkt; `beginne` im SELBEN Zug zählt ihn (ein Beitrag aus einem
 *        früheren Zug nie) — liest er noch vor, öffnet das Ende des Vorlesens, sonst sofort;
 *      - läuft die Frist ab, während vorgelesen wird, öffnet das Ende des Vorlesens (nicht mitten hinein) — auch wenn der
 *        gelesene Beitrag nicht zu diesem Warten gehört.
 *
 * ⚠️ 16.10.2026, 07:21–07:24 (Martin: „Jetzt hätte ich eigentlich wieder ein Mikro bekommen sollen.“) — ÜBERSPRUNGEN OHNE
 *    WIEDERHOLUNG. Vespera war fertig vorgelesen, das Mikro sollte nach ihrer Frage öffnen; im Ausklang begann aber die Stimme
 *    des Schmieds (`[ptt] nach-frage übersprungen wiedergabe`, lib/ausklang.ts) — und nach ihm versuchte niemand mehr zu öffnen.
 *    Darum `mikroNachVorlesen`: wurde das Mikro übersprungen, während Beiträge des Schmieds anstehen, löst es GENAU EINMAL ein,
 *    wenn der LETZTE vorgelesen ist (`vorlesenOffen` fällt auf 0) — nie nach dem ersten von zweien. `verwirf` (Stopp, neues
 *    Warten) macht es stumm; ob es dann wirklich aufgeht (gleicher Zug, Ruhezustand …), prüft der Rückruf in app.ts.
 *
 * ⚠️ 16.10.2026, 18:19 (Martin: „das Mikro soll zu bleiben, bis Vespera geantwortet hat“) — HALT AN VESPERA. Journal:
 *    `[dreier] beitrag … an=vespera` um 18:19:36, `[ptt] nach-frage schmied weil=vorgelesen` um 18:19:57 — das Mikro ging für
 *    Martin auf, obwohl der Beitrag an Vespera ging. Darum: ein Beitrag `an: "vespera"` (ohne `weiter`, ohne Ja/Nein-Frage,
 *    `haltAnVesperaGilt`) beginnt einen HALT. Solange er gilt, öffnet NICHTS: kein Warten-auf-Beitrag, keine Frist, kein
 *    übersprungenes Mikro nach dem Vorlesen. Er endet
 *      - wenn Vespera geantwortet hat (`vesperaAntwortet`: das Ende eines Zuges, der NICHT schon fertig war, als der Beitrag
 *        kam) — dann entscheidet ihre Antwort nach den normalen Regeln (app.ts, mikroNachAntwort); das alte Warten verfällt;
 *      - wenn Martin den Schmied anspricht (`beginne` ohne Zug) oder ein neuer Beitrag des Schmieds kommt (an Martin, ohne
 *        Feld, `weiter`) — dann gilt dessen Regel;
 *      - spätestens SCHMIED_AN_VESPERA_MS nach dem Ende seines Vorlesens (Vespera antwortet nicht: Fehler, Abbruch, kein Zug)
 *        — dann öffnet, was ohne Halt geöffnet hätte (Warten: Grund „vespera-schweigt“, sonst das gemerkte Mikro).
 *    Stopp und Sprechtaste bleiben wirksam (app.ts prüft beim Öffnen Zug und Ruhezustand). Notschalter am Server:
 *    `SCHMIED_AN_VESPERA_HALT=0` (server/dreier-routen.ts) — der Beitrag trägt dann `mikroWieBisher: true`, kein Halt.

 * ⚠️⚠️ 16.10.2026, 18:29 (Martin, außer sich: „zum letzten Mal“) — DIE ANZEIGE „SCHMIED ARBEITET“ HÄLT DAS MIKRO.
 *    Stand die Warteblase „Schmied arbeitet / bereitet eine Antwort vor“ (lib/schmied-warteblase.ts) noch im Chat, ging das Mikro
 *    nach 20 s trotzdem auf (`[ptt] nach-frage schmied weil=frist`). Jetzt fragt der Fristablauf zuerst `arbeitet()`:
 *      - steht die Anzeige, öffnet nichts — geprüft wird alle SCHMIED_STATUS_PRUEF_MS erneut (Journal einmal:
 *        `[schmied] frist-verlaengert arbeitet=ja`);
 *      - kommt ein Beitrag, gilt wieder die alte Regel (öffnet sofort bzw. nach dem Vorlesen);
 *      - endet die Anzeige ohne Beitrag, öffnet es nach SCHMIED_STATUS_SCHONFRIST_MS (`weil=status-ende`) — ein Beitrag, der kurz
 *        nach dem „aus“ eintrifft, öffnet in dieser Zeit wie immer selbst; steht sie danach wieder, wird weiter gewartet;
 *      - spätestens SCHMIED_STATUS_GRENZE_MS nach dem ersten Fristablauf öffnet es trotzdem (`weil=obergrenze`), nie dauerhaft zu.
 *    Ein Stopp, die Sprechtaste (`verwirfVerlaengerung`, stopCurrentTts) beenden ein so verlängertes Warten ohne Öffnen.
 *    Woher `arbeitet` kommt (app.ts): die Warteblase steht (`sichtbar`) und der Server hat den Schalter nicht abgedreht
 *    (`SCHMIED_STATUS_HAELT_MIKRO=0` → Stand `mikroFrei`). Ohne `arbeitet` (Tests, alte Aufrufer): genau das alte Verhalten.
 *
 * ⚠️ 16.10.2026, 20:01 (Martin: nach reinen Infomeldungen öffnete sein Mikro trotzdem) — „NUR ZUR INFO“ (Feld `info`, anders als `weiter`).
 *    Ein Beitrag mit der Marke wird vorgelesen wie jeder andere, aber danach öffnet NICHTS und es wartet auch nichts auf den Schmied:
 *    ein wartendes Mikro, ein gemerktes übersprungenes Mikro, ein Halt an Vespera und ein Beitrag davor werden verworfen
 *    (`beitragKam(…, info)`, `vorgelesen(…, info)`). `weiter` wartet dagegen bis zum nächsten Beitrag (5 min). Kam er vor dem Warten,
 *    merkt ihn `vorab`; `beginne` im selben Zug wartet dann nicht. Das Mikro öffnet wieder durch Martins Druck oder die Regel
 *    eines neuen Zuges (shared/mikro-nach-antwort.ts) — nie durch diesen Beitrag. Frage und `weiter` gehen vor (infoAus, Server und App).
 *
 * ⚠️ 17.10.2026, 11:15–11:19 (Martin, genervt: „bei Vespera geht das Mikro nach einer Frage auf, beim Schmied nicht“) — DIE FRAGE
 *    DES SCHMIEDS. Journal 11:16:42: `[dreier] beitrag … frage=- weiter=0 info=0` („… Sagst du mir nach dem Test, wie es war?“)
 *    — und danach keine einzige `[ptt]`-Zeile. Ursache: geöffnet hat bisher NUR ein laufendes Warten (`beginne`: Vespera oder
 *    Martin hat den Schmied angesprochen). Die Infomeldungen um 11:15:37 hatten dieses Warten beendet (`--info`, so gewollt);
 *    der Beitrag mit der Frage fand nichts Wartendes, wurde als `vorab` gemerkt — und es kam kein `beginne` mehr. Ob er eine
 *    Frage stellte, zählte nirgends. Darum `frageKam` (app.ts nur bei `schmiedFragtMartin`): wartet NICHTS, öffnet ein Beitrag
 *    mit Frage an Martin selbst — nach dem Ende seines Vorlesens (nur, wenn er wirklich gehört wurde), oder, wird er nicht
 *    vorgelesen, nach der Lesefrist ab der Anzeige (shared/schmied.ts `schmiedFrageLeseMs`; spricht dann gerade ein anderer
 *    Beitrag, an dessen Ende). Wartet etwas, gilt die alte Regel (der Beitrag löst das Warten ein). Der LETZTE Beitrag
 *    entscheidet: jeder spätere (Aussage, `weiter`, `info`, an Vespera) verwirft die offene Frage; ebenso `beginne`,
 *    `abbrechen`, `nichtVorn` (andere Seite vorn), `fertig` und ein Stopp (`verwirfMikroNachVorlesen`).
 *
 * ⚠️ Ob überhaupt geöffnet werden DARF (Stufe, Zustand der Sprechtaste, Vordergrund), entscheidet weiter der Hörer in
 *    app.ts (shared/mikro-nach-antwort.ts, `nachAusklang`). Hier steht nur das WANN.
 */
import { adressatAus, type Adressat } from "../../shared/dreier-adressat.js";
import { frageAus, infoAus, weiterAus } from "../../shared/entwickler-im-chat.js";
import { endetMitFrage } from "./frage-am-ende.js";
import {
  SCHMIED_AN_VESPERA_MS,
  SCHMIED_STATUS_GRENZE_MS,
  SCHMIED_STATUS_PRUEF_MS,
  SCHMIED_STATUS_SCHONFRIST_MS,
  SCHMIED_WARTEN_MS,
  SCHMIED_WEITER_MS,
} from "../../shared/schmied.js";

export type SchmiedOeffnetWeil =
  | "frage-vorgelesen"
  | "frage-gelesen"
  | "beitrag"
  | "vorgelesen"
  | "verworfen"
  | "frist"
  | "vespera-schweigt"
  | "status-ende"
  | "obergrenze"
  | "nach-wiedergabe";

/**
 * 17.10.2026 (Messung 6 h): ein Öffnen wegen `frist`, `status-ende` oder `obergrenze` folgt keiner GEHÖRTEN Frage — das 3-s-Mikro
 * ging auf, Martin war nicht bereit, ein späteres „Ja“ fand es zu. Darum öffnet es dann nicht, sondern zeigt nur diesen leisen
 * Hinweis (das Mikro ist zu). AUSNAHME: `frageOffen` — Vesperas letzte Antwort endete mit einer Frage/Entscheidung an Martin
 * (mikroNachAntwort `wartetAufMartin`); dann gilt „Frage öffnet das Mikro“ weiter wie bisher. Rein.
 */
export const MIKRO_BEREIT_HINWEIS = "Zum Antworten aufs Mikro tippen";
export function nurHinweisStattMikro(weil: SchmiedOeffnetWeil, frageOffen: boolean): boolean {
  if (frageOffen) return false;
  return weil === "frist" || weil === "status-ende" || weil === "obergrenze";
}

/**
 * Hält dieser Beitrag das Mikro für Vespera zu (oben, „Halt an Vespera“)? Nur `an: "vespera"`, keine Ja/Nein-Frage an Martin
 * (die Knöpfe gelten ihm), und nicht, wenn der Server den Notschalter meldet (`mikroWieBisher`). Rein. „Ich arbeite noch“
 * (`weiter`) hat Vorrang — das entscheidet `beitragKam`.
 */
export function haltAnVesperaGilt(b: { an: unknown; frage: unknown; mikroWieBisher: unknown }): boolean {
  return adressatAus(b.an) === "vespera" && b.frage == null && b.mikroWieBisher !== true;
}

/**
 * 22.10.2026 (Martin 10:20/10:26, Journal `nach-frage zimmermann weil=vorgelesen`): an wen AUSSER Martin geht ein Beitrag ausdrücklich?
 * Der gültige Adressat aus dem Feld (`an` des Schmieds bzw. `ziel` von Zimmermann/Hüter — beide nur vom Server, nie aus dem Text), wenn
 * er nicht Martin ist und Martin auch nicht zweiter Adressat (`sekundaer`) ist — sonst `null` (ohne Feld: wie bisher). Rein.
 */
export function zielOhneMartin(an: unknown, sekundaer?: unknown): Adressat | null {
  const a = adressatAus(an);
  if (a === null || a === "martin" || adressatAus(sekundaer) === "martin") return null;
  return a;
}

/** Beim Schmied: geht sein Beitrag an Zimmermann/Hüter (`zielOhneMartin`)? Ein Beitrag an Vespera hat seinen eigenen Halt (oben). Rein. */
export function schmiedAnAndereEntwickler(an: unknown, sekundaer?: unknown): boolean {
  const z = zielOhneMartin(an, sekundaer);
  return z !== null && z !== "vespera";
}

/**
 * Fragt dieser Beitrag MARTIN (oben, 17.10. 11:15)? Ja bei `--ja-nein`; sonst, wenn der Text wie bei Vespera mit einer echten Frage
 * endet (lib/frage-am-ende.ts `endetMitFrage`). Nie bei `weiter` („Schmied arbeitet“), nie bei `info`, nie, wenn er an Vespera oder den
 * Schmied geht (ohne `an` oder `an: "martin"` gilt er Martin). Rein — dieselben strengen Leser wie app.ts.
 */
export function schmiedFragtMartin(b: { text: string; frage: unknown; weiter: unknown; info: unknown; an: unknown; erwartet?: unknown }): boolean {
  const frage = frageAus(b.frage);
  const weiter = weiterAus(b.weiter, frage);
  if (weiter || infoAus(b.info, frage, weiter)) return false;
  if (frage) return true;
  const an = adressatAus(b.an);
  if (an !== null && an !== "martin") return false;
  // 18.10.2026: der Server-Richter (server/antwort-erwartet.ts) meinte „erwartet eine Antwort“ — nur ein ausdrückliches `true` gilt; öffnet nur das Mikro.
  if (b.erwartet === true) return true;
  return endetMitFrage(ohneCode(b.text));
}

/**
 * 28.10.2026: der Kurzstand vom SERVER mit `weiter` (server/schmied-kurzstand.ts — nur, wenn der Schmied mithört) geht am Warten vorbei:
 * er verlängert die Frist nicht auf SCHMIED_WEITER_MS, zählt nicht als Antwort und verwirft keine offene Frage — die echte Antwort
 * des Schmieds entscheidet. Ohne `weiter` (Schmied hört nicht mit) ist er die Antwort und läuft wie jeder Beitrag. Rein.
 */
export function kurzstandOhneWarten(b: { kurzstand: unknown; weiter: unknown }): boolean {
  return b.kurzstand === true && weiterAus(b.weiter, null) === true;
}

/**
 * Der Text ohne Code (Prüfauflage 17.10.): der Schmied schickt oft Code — ein Codeblock oder Inline-Code, der mit `? :` oder
 * einem `?` endet, ist keine Frage an Martin. Codeblöcke (auch ein nicht geschlossener am Ende) und Inline-Code fallen weg. Rein.
 */
export function ohneCode(text: string): string {
  return (text ?? "").replace(/```[\s\S]*?(?:```|$)/g, "\n\n").replace(/`[^`\n]*`/g, " ");
}

/** So lange nach dem letzten echten Tastendruck in einem Feld gilt „Martin tippt“ (21.10.2026). */
export const TIPP_FENSTER_MS = 4000;

/** Steht der Fokus in einem Eingabefeld (input, textarea, editierbar)? Rein. */
export function imEingabefeld(a: { tagName?: string; isContentEditable?: boolean } | null): boolean {
  if (!a) return false;
  return a.isContentEditable === true || /^(INPUT|TEXTAREA)$/i.test(a.tagName ?? "");
}

/**
 * Tippt Martin gerade (Prüfauflage 17.10.)? Dann öffnet eine Frage das Mikro NICHT (es fiele mitten in seine getippte Antwort). Rein.
 *
 * 21.10.2026 (Martin 19:58, `nach-frage übersprungen tippt`, 20× `vorstart nein grund=tippt` in einer Stunde am Rechner): bisher
 * zählte schon der Fokus im Feld oder stehender Text im Chatfeld. Am Rechner bleibt der Fokus nach dem Senden im Feld (ein Klick
 * auf die Sprechtaste nimmt ihn nicht weg), und die Vollständigkeits-Bremse legt halbe Sätze ins Feld — das Mikro blieb so
 * dauerhaft zu. Jetzt gilt nur noch WIRKLICHES Tippen: Fokus in einem Eingabefeld UND ein echter Tastendruck dort in den letzten
 * `TIPP_FENSTER_MS`. Text, den das System ins Feld legt, ist kein Tastendruck.
 * Auflage Sicherheitsprüfer (21.10.): stehender Text im Chatfeld zählt weiter als „tippt“ (ein getippter Entwurf) — AUSSER er
 * stammt unverändert aus der Vollständigkeits-Bremse (`feldAusBremse`, lib/bremse-feld.ts). Martins Fall 19:58 (Feld leer,
 * Fokus im Feld) bleibt gelöst.
 */
export function martinTippt(o: {
  aktiv: { tagName?: string; isContentEditable?: boolean } | null;
  letzteTasteVorMs: number | null;
  feldText: string | null;
  feldAusBremse: boolean;
}): boolean {
  if ((o.feldText ?? "").trim() !== "" && !o.feldAusBremse) return true;
  if (!imEingabefeld(o.aktiv)) return false;
  const vor = o.letzteTasteVorMs;
  return vor !== null && Number.isFinite(vor) && vor >= 0 && vor <= TIPP_FENSTER_MS;
}

/**
 * Auflage Sicherheitsprüfer (21.10.2026): ein echter Tastendruck in einem Feld schließt ein VON SELBST geöffnetes Mikro (nach
 * Frage/Antwort) still — aber nur, solange es noch keine Sprache hörte. Ein selbst gedrücktes Mikro und laufende Rede bleiben. Rein.
 */
export function tasteSchliesstMikro(l: { aufnahme: boolean; vonSelbst: boolean; ohneSprache: boolean }): boolean {
  return l.aufnahme && l.vonSelbst && l.ohneSprache;
}

/**
 * 21.10.2026 (Martin: „da kann doch irgendeine Meldung kommen, dass man weiß, was im Hintergrund läuft“): eine Frage wartete, das
 * Mikro blieb aber zu, weil er tippte. Dann — nach `TIPP_HINWEIS_NACH_MS`, nie sofort — eine leise Zeile, aber nur, wenn er inzwischen
 * NICHT mehr tippt (wer tippt, antwortet schriftlich), derselbe Zug noch gilt, nichts aufnimmt, die Seite vorn und sichtbar ist.
 * Der Hinweis öffnet nichts. Rein.
 */
export const TIPP_HINWEIS_NACH_MS = 6000;
export const TIPP_SPERRE_HINWEIS = "Mikro blieb zu, weil du getippt hast – zum Antworten aufs Mikro tippen";
export function tippHinweisZeigen(l: { gleicherZug: boolean; ruhe: boolean; sichtbar: boolean; vorn: boolean; tipptNoch: boolean }): boolean {
  return l.gleicherZug && l.ruhe && l.sichtbar && l.vorn && !l.tipptNoch;
}

/** Die Anzeige „Schmied arbeitet“ (oben, 16.10. 18:29). Beides optional: ohne `arbeitet` hält nichts das Mikro. */
export interface SchmiedStatusHalt {
  /** Steht die Anzeige gerade — und darf sie das Mikro halten (Schalter)? */
  arbeitet?: () => boolean;
  /** Eine Journalzeile (ohne Textinhalt). */
  melde?: (zeile: string) => void;
}

interface Uhr {
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(h: unknown): void;
}

const echteUhr: Uhr = {
  setTimeout: (fn, ms) => globalThis.setTimeout(fn, ms),
  clearTimeout: (h) => globalThis.clearTimeout(h as ReturnType<typeof setTimeout>),
};

export class SchmiedWarten {
  private oeffne: ((weil: SchmiedOeffnetWeil) => void) | null = null;
  private frist: unknown = null;
  /** Für das laufende Warten kam ein Beitrag. */
  private gezaehlt = false;
  /** Das laufende Warten ist eine Vespera-Frage AN MARTIN (via nach-frage): Info/Beitrag an Andere schließt sie nicht (28.10.2026). */
  private vesperaFrage = false;
  /** Die Frist des laufenden Wartens ist abgelaufen, während vorgelesen wurde. */
  private fristAbgelaufen = false;
  /** Wie viele Beiträge noch vorgelesen werden (angenommen, aber `vorgelesen` steht aus) — unabhängig vom Warten. */
  private vorlesenOffen = 0;
  /** Ein Beitrag, der kam, als nichts wartete — mit seinem Zug (`null`: keinem zuzuordnen). */
  private vorab: { zug: number | null; vorlesen: boolean; verworfen: boolean; info?: boolean } | null = null;
  /** Ein übersprungenes Mikro, das nach dem letzten vorgelesenen Beitrag noch einmal versucht (oben, 16.10.). */
  private nachVorlesen: (() => void) | null = null;
  /**
   * Halt an Vespera (oben, 18:19). `alterZug`: der Zug, der schon FERTIG war, als der Beitrag kam — sein Ende ist nicht ihre
   * Antwort (`null`: ein laufender Zug, sein Ende zählt). `frist`: die Obergrenze, läuft ab dem Ende des Vorlesens.
   */
  private halt: { alterZug: number | null; frist: unknown } | null = null;
  /** Die Frist lief ab, während die Anzeige „Schmied arbeitet“ stand — das Mikro bleibt zu (oben, 16.10. 18:29). */
  private verlaengert = false;
  /** Die Anzeige endete ohne Beitrag; die Schonfrist läuft. */
  private schonfrist = false;
  /** Die harte Obergrenze des verlängerten Wartens. */
  private grenze: unknown = null;
  private grenzeErreicht = false;
  /**
   * Eine Frage an Martin, die nichts Wartendes fand (oben, 17.10. 11:15). `vorlesen`: sie wird vorgelesen — dann öffnet das Ende
   * des Vorlesens; sonst die Lesefrist (`uhr`). `lesenUm`: die Lesefrist lief ab, während ein anderer Beitrag vorgelesen wurde.
   */
  private frage: { oeffne: (weil: SchmiedOeffnetWeil) => void; vorlesen: boolean; uhr: unknown; lesenUm: boolean } | null = null;
  /**
   * 19.10.2026 (Martin 13:37): das Frage-Mikro eines Entwicklers entfiel im Ausklang, weil ein ANDERER Beitrag (eine Info) zu sprechen begann —
   * es versucht GENAU EINMAL nach dem Ende dieses Vorlesens noch einmal. Eine Info löscht es nie (anders als `nachVorlesen`).
   */
  private frageNachher: (() => void) | null = null;

  constructor(
    private readonly uhr: Uhr = echteUhr,
    private readonly fristMs: number = SCHMIED_WARTEN_MS,
    private readonly status: SchmiedStatusHalt = {},
    private readonly haltMs: number = SCHMIED_AN_VESPERA_MS,
  ) {}

  /** Hält gerade ein Beitrag an Vespera das Mikro zu? */
  haeltFuerVespera(): boolean {
    return this.halt !== null;
  }

  /** Wartet gerade etwas auf den Schmied? */
  wartet(): boolean {
    return this.oeffne !== null;
  }

  /**
   * Nur ansehen (Mikro-Vorstart, mikro-vorstart.ts): öffnet das Ende des Vorlesens, das gerade läuft, das Mikro? Ja, wenn dies das
   * LETZTE offene Vorlesen ist, kein Halt an Vespera besteht und entweder eine Frage des Schmieds an Martin auf das Vorlesen wartet
   * oder ein gezähltes Warten (Vesperas Anrede / Martins Ansprache) dran ist. Im Zweifel `false` — dann gibt es keinen Vorstart.
   */
  oeffnetNachVorlesen(): boolean {
    if (this.vorlesenOffen > 1 || this.halt) return false;
    if (this.oeffne) return this.gezaehlt;
    return this.frage !== null && this.frage.vorlesen;
  }

  /** Steht eine Frage des Schmieds an Martin aus, die das Mikro noch öffnen will (oben, 17.10. 11:15)? */
  frageOffen(): boolean {
    return this.frage !== null;
  }

  /**
   * Der Beitrag, der eben `beitragKam` meldete, fragt Martin (`schmiedFragtMartin`) — IMMER direkt danach rufen. Wartet etwas oder
   * hält ein Halt, entscheidet das (nichts zu tun). Sonst öffnet `oeffne` genau einmal: nach dem Ende des Vorlesens (`vorlesen`,
   * nur wenn gehört: „frage-vorgelesen“) bzw. nach `leseMs` ab jetzt („frage-gelesen“; liest gerade ein anderer Beitrag vor, an
   * dessen Ende). Ob es dann wirklich aufgeht (Stufe, Zug, Ruhezustand, vorderes Gerät), prüft der Rückruf in app.ts.
   */
  frageKam(vorlesen: boolean, leseMs: number, oeffne: (weil: SchmiedOeffnetWeil) => void): void {
    this.verwirfFrage();
    this.frageNachher = null;
    if (this.oeffne || this.halt) return;
    // Die Frage entscheidet jetzt allein — ein älteres übersprungenes Mikro löst nicht zusätzlich ein.
    this.nachVorlesen = null;
    const f: { oeffne: (weil: SchmiedOeffnetWeil) => void; vorlesen: boolean; uhr: unknown; lesenUm: boolean } = {
      oeffne,
      vorlesen,
      uhr: null,
      lesenUm: false,
    };
    this.frage = f;
    if (vorlesen) return;
    f.uhr = this.uhr.setTimeout(() => {
      f.uhr = null;
      if (this.frage !== f) return;
      if (this.vorlesenOffen > 0) {
        f.lesenUm = true; // nicht mitten in eine Stimme — das Ende des Vorlesens löst ein
        return;
      }
      this.loeseFrage("frage-gelesen");
    }, Math.max(0, leseMs));
  }

  /** Eine offene Frage nach dem Ende des LETZTEN Vorlesens: einlösen oder verwerfen. `true`, wenn eine Frage da war. */
  private frageNachVorlesen(gehoert: boolean): boolean {
    const f = this.frage;
    if (!f) return false;
    if (f.vorlesen) {
      // Abgebrochen oder nicht gehört (Stopp, keine Stille, ausgeschaltet): Martin hat gehandelt oder nichts gehört — zu.
      if (gehoert) this.loeseFrage("frage-vorgelesen");
      else this.verwirfFrage();
    } else if (f.lesenUm) {
      this.loeseFrage("frage-gelesen");
    }
    return true;
  }

  private loeseFrage(weil: SchmiedOeffnetWeil): void {
    const f = this.frage;
    this.verwirfFrage();
    f?.oeffne(weil);
  }

  private verwirfFrage(): boolean {
    const f = this.frage;
    if (!f) return false;
    if (f.uhr !== null) this.uhr.clearTimeout(f.uhr);
    this.frage = null;
    return true;
  }

  /**
   * Das Mikro wartet auf den Schmied (ersetzt ein altes Warten). `zug`: der Zug, dessen Ende angesprochen hat — kam in
   * DIESEM Zug schon ein Beitrag, zählt er (oben). Ohne Zug (`null`, Martin hat ihn angesprochen) zählt nur ein neuer.
   */
  beginne(oeffne: (weil: SchmiedOeffnetWeil) => void, zug: number | null = null, vesperaFrage = false): void {
    this.abbrechen();
    this.vesperaFrage = vesperaFrage;
    // Das neue Warten entscheidet jetzt allein über das Öffnen — ein älteres übersprungenes Mikro löst nicht zusätzlich ein.
    this.nachVorlesen = null;
    // Martin hat den Schmied angesprochen (ohne Zug) oder ein neuerer Zug Vesperas endete: der Halt an Vespera ist vorbei.
    // Nur das Ende des Zuges, der schon fertig war, als der Beitrag kam, lässt ihn stehen (ihre Antwort steht noch aus).
    if (this.halt && (zug === null || zug !== this.halt.alterZug)) this.beendeHalt();
    this.oeffne = oeffne;
    const vorab = this.vorab;
    this.vorab = null;
    if (vorab && zug !== null && vorab.zug === zug) {
      if (vorab.info) {
        // Die Infomeldung kam schon in diesem Zug: kein Warten auf den Schmied, nichts öffnet (oben, 20:01).
        this.oeffne = null;
        return;
      }
      this.gezaehlt = true;
      if (this.vorlesenOffen === 0) {
        this.loese(vorab.verworfen ? "verworfen" : vorab.vorlesen ? "vorgelesen" : "beitrag");
        return;
      }
    }
    this.starteFrist();
  }

  private starteFrist(ms: number = this.fristMs): void {
    if (this.frist !== null) this.uhr.clearTimeout(this.frist);
    this.frist = this.uhr.setTimeout(() => {
      this.frist = null;
      // Hält ein Beitrag an Vespera das Mikro zu, öffnet die gewöhnliche Frist nichts — die Obergrenze des Halts entscheidet.
      if (this.halt) return;
      this.fristUm();
    }, ms);
  }

  /**
   * Die Frist (oder eine Nachprüfung) ist um. Liest der Schmied gerade vor, wartet das Mikro auf das Ende seiner Stimme (nicht
   * mitten hinein). Steht die Anzeige „Schmied arbeitet“, bleibt es zu und prüft erneut (oben, 16.10. 18:29).
   */
  private fristUm(): void {
    if (!this.oeffne) return;
    if (this.vorlesenOffen > 0) {
      this.fristAbgelaufen = true;
      return;
    }
    if (this.grenzeErreicht) {
      this.loese("obergrenze");
      return;
    }
    if (this.statusArbeitet()) {
      if (!this.verlaengert) {
        this.verlaengert = true;
        this.grenze = this.uhr.setTimeout(() => this.grenzeUm(), SCHMIED_STATUS_GRENZE_MS);
        this.melde(`[schmied] frist-verlaengert arbeitet=ja grenze=${Math.round(SCHMIED_STATUS_GRENZE_MS / 1000)}s`);
      }
      this.schonfrist = false;
      this.starteFrist(SCHMIED_STATUS_PRUEF_MS);
      return;
    }
    if (this.verlaengert && !this.schonfrist) {
      this.schonfrist = true;
      this.melde(`[schmied] frist-verlaengert arbeitet=nein schonfrist=${Math.round(SCHMIED_STATUS_SCHONFRIST_MS / 1000)}s`);
      this.starteFrist(SCHMIED_STATUS_SCHONFRIST_MS);
      return;
    }
    this.loese(this.verlaengert ? "status-ende" : "frist");
  }

  /** Die harte Obergrenze ist erreicht: öffnen — nur nicht mitten in eine Stimme des Schmieds (dann an ihrem Ende). */
  private grenzeUm(): void {
    this.grenze = null;
    this.grenzeErreicht = true;
    this.melde(`[schmied] frist-verlaengert arbeitet=${this.statusArbeitet() ? "ja" : "nein"} grenze=erreicht`);
    if (this.frist !== null) this.uhr.clearTimeout(this.frist);
    this.frist = null;
    this.fristUm();
  }

  private statusArbeitet(): boolean {
    try {
      return this.status.arbeitet?.() === true;
    } catch {
      return false; // lieber das alte Verhalten als ein hängendes Mikro
    }
  }

  private melde(zeile: string): void {
    try {
      this.status.melde?.(zeile);
    } catch {
      /* Journal ist Beiwerk */
    }
  }

  /** Ein Beitrag kam: das verlängerte Warten endet, es gilt wieder die Regel für Beiträge. */
  private beendeVerlaengerung(): void {
    if (this.grenze !== null) this.uhr.clearTimeout(this.grenze);
    this.grenze = null;
    this.grenzeErreicht = false;
    this.verlaengert = false;
    this.schonfrist = false;
  }

  /**
   * Ein Beitrag des Schmieds kam. `vorlesen`: er wird jetzt vorgelesen — dann ruft der Aufrufer danach GENAU EINMAL
   * `vorgelesen` (fertig, abgebrochen oder gescheitert). `zug`: der laufende Zug (für einen Beitrag vor dem Warten).
   */
  beitragKam(
    vorlesen: boolean,
    zug: number | null = null,
    weiter = false,
    /** Halt an Vespera (`haltAnVesperaGilt`): mit dem Zug, der beim Eintreffen schon fertig war (`null`: keiner/laufend). */
    anVespera: { alterZug: number | null } | null = null,
    /** „Nur zur Info“ (`infoAus`, oben): nichts öffnet, nichts wartet. Frage und `weiter` hat der Aufrufer schon vorgezogen. */
    info = false,
    /**
     * 22.10.2026: der Beitrag geht ausdrücklich an einen ANDEREN Entwickler (`zielOhneMartin`, ohne Vespera beim Schmied — die hat ihren
     * Halt). Er ist keine Antwort an Martin: ein noch nicht beantwortetes Warten endet ZU, ein Beitrag vor dem Warten zählt nicht.
     * Nur seltener: ein schon gezähltes Warten und alles andere bleiben wie bisher.
     */
    anAndere = false,
  ): void {
    if (vorlesen) this.vorlesenOffen++;
    // Der LETZTE Beitrag entscheidet: eine offene Frage gilt nicht mehr (fragt auch dieser, setzt `frageKam` sie neu).
    // AUSNAHME (19.10.2026): eine Info (`info`, ohne `weiter`) bricht eine offene Frage nie ab und ersetzt sie nicht.
    if (!(info && !weiter)) {
      this.verwirfFrage();
      this.frageNachher = null;
    }
    if (info && !weiter) {
      this.beendeHalt();
      // 28.10.2026: eine offene Vespera-Frage an Martin überlebt die Info — weiter warten bis Vorlesen/Frist.
      if (this.oeffne && this.vesperaFrage) {
        this.melde("[ptt] mikro warten bleibt grund=info-bei-vespera-frage");
        return;
      }
      this.nachVorlesen = null;
      this.warteAbbrechen();
      this.vorab = { zug, vorlesen, verworfen: false, info: true };
      return;
    }
    if (anVespera && !weiter) {
      // Der Beitrag geht an Vespera: nichts öffnet für Martin, bis sie antwortet (oben). Ein früherer Beitrag zählt nicht mehr,
      // eine laufende Frist auch nicht; die Obergrenze beginnt mit dem Ende des Vorlesens (ohne Vorlesen: jetzt).
      this.beendeHalt();
      this.halt = { alterZug: anVespera.alterZug, frist: null };
      this.vorab = null;
      this.gezaehlt = false;
      this.fristAbgelaufen = false;
      if (this.frist !== null) this.uhr.clearTimeout(this.frist);
      this.frist = null;
      if (this.vorlesenOffen === 0) this.starteHalt();
      return;
    }
    // Jeder andere Beitrag beendet einen Halt — dann gilt seine Regel.
    this.beendeHalt();
    // 22.10.2026 (Martin 10:26): Zimmermanns Frage an den Schmied löste das Warten auf Zimmermann ein — Martins Mikro ging auf. Ein Beitrag
    // an einen anderen Entwickler ist keine Antwort an Martin: das unbeantwortete Warten endet zu (wie eine Info, samt gemerktem Mikro),
    // ohne Warten zählt er später nicht (`vorab` als Info). War das Warten schon von einem Beitrag an Martin gezählt: wie bisher (unten).
    if (anAndere && !weiter && this.oeffne && this.vesperaFrage) {
      this.melde("[ptt] mikro warten bleibt grund=an-andere-bei-vespera-frage");
      return;
    }
    if (anAndere && !weiter && !(this.oeffne && this.gezaehlt)) {
      if (this.oeffne) {
        this.nachVorlesen = null;
        this.warteAbbrechen();
        this.melde("[ptt] mikro warten zu grund=an-andere");
      }
      this.vorab = { zug, vorlesen, verworfen: false, info: true };
      return;
    }
    if (weiter) {
      // „Ich arbeite noch“ (16.10.2026, Feld `weiter`): der Beitrag öffnet nichts und ein früherer, noch nicht eingelöster
      // zählt nicht mehr. Das wartende Mikro bleibt zu; die lange Frist SCHMIED_WEITER_MS (5 min) beginnt (Rückfall, damit Martin nicht endlos festhängt).
      this.vorab = null;
      this.gezaehlt = false;
      this.fristAbgelaufen = false;
      this.beendeVerlaengerung();
      if (this.oeffne) this.starteFrist(SCHMIED_WEITER_MS);
      return;
    }
    if (!this.oeffne) {
      this.vorab = { zug, vorlesen, verworfen: false };
      return;
    }
    this.gezaehlt = true;
    this.beendeVerlaengerung();
    if (this.vorlesenOffen === 0) this.loese("beitrag");
  }

  /**
   * Das Vorlesen eines Beitrags ist zu Ende (fertig, abgebrochen oder gescheitert). `gehoert`: Martin hat ihn wirklich
   * gehört. `false` (verworfen, z. B. keine Stille bis zur Grenze): das Mikro öffnet trotzdem (sonst hinge Martin fest),
   * aber mit dem EHRLICHEN Grund „verworfen“ — nicht „vorgelesen“. Der Zähler läuft in beiden Fällen genau einmal.
   */
  vorgelesen(gehoert = true, weiter = false, info = false): void {
    this.vorgelesenIntern(gehoert, weiter, info);
    // Das Frage-Mikro, das wegen dieser Stimme entfiel (`frageMikroNachWiedergabe`): nach dem LETZTEN Vorlesen genau einmal noch einmal.
    if (this.vorlesenOffen === 0 && this.frageNachher) {
      const nochmal = this.frageNachher;
      this.frageNachher = null;
      nochmal();
    }
  }

  /**
   * Das Frage-Mikro eines Entwicklers entfiel im Ausklang, weil eine Stimme (z. B. eine Info) begann. Wird hier noch vorgelesen, versucht
   * das Ende des LETZTEN Vorlesens es genau einmal noch einmal — `true`; sonst `false` (nichts gemerkt). Stopp/Sprechtaste verwerfen es.
   */
  frageMikroNachWiedergabe(nochmal: () => void): boolean {
    if (this.vorlesenOffen === 0) return false;
    this.frageNachher = nochmal;
    return true;
  }

  private vorgelesenIntern(gehoert: boolean, weiter: boolean, info: boolean): void {
    if (this.vorlesenOffen > 0) this.vorlesenOffen--;
    // Nur zur Info: nichts einlösen — ein inzwischen gemerktes übersprungenes Mikro verfällt, nichts öffnet (oben, 20:01).
    if (info && !weiter) {
      if (this.vorlesenOffen === 0) {
        this.nachVorlesen = null;
        this.frageNachVorlesen(gehoert); // eine nicht vorgelesene Frage, deren Lesefrist schon um ist
      }
      return;
    }
    if (!gehoert && this.vorab) this.vorab.verworfen = true; // endete vor dem Warten: der Grund bleibt ehrlich
    if (this.vorlesenOffen > 0) return;
    // Halt an Vespera: nichts öffnet — die Obergrenze beginnt jetzt, am Ende des Vorlesens (ein gemerktes Mikro bleibt liegen).
    if (this.halt) {
      if (this.halt.frist === null) this.starteHalt();
      return;
    }
    // Ein Beitrag „ich arbeite noch“ ist zu Ende gelesen: nichts öffnet (ein gemerktes Mikro bleibt für den nächsten Beitrag).
    if (weiter && !this.gezaehlt) {
      if (this.oeffne && this.fristAbgelaufen) this.fristNachVorlesen();
      // Prüfauflage 17.10.: eine SPÄTERE Frage (ihre Lesefrist lief während dieser Stimme ab) löst jetzt ein — sie bleibt nie liegen.
      else if (!this.oeffne) this.frageNachVorlesen(gehoert);
      return;
    }
    // Die Schlange ist leer: höchstens EIN Öffnen — ein laufendes Warten hat Vorrang (es öffnet selbst, spätestens mit der
    // Frist), das übersprungene Mikro verfällt dann.
    const nach = this.nachVorlesen;
    this.nachVorlesen = null;
    if (this.oeffne) {
      if (this.gezaehlt) this.loese(gehoert ? "vorgelesen" : "verworfen");
      else if (this.fristAbgelaufen) this.fristNachVorlesen();
      return;
    }
    // Eine Frage des Schmieds an Martin (oben, 17.10.) entscheidet allein — höchstens EIN Öffnen.
    if (this.frageNachVorlesen(gehoert)) return;
    nach?.();
  }

  /**
   * Das Auto-Mikro wurde übersprungen, weil eine Stimme begann. Stehen Beiträge des Schmieds zum Vorlesen an, ruft das Ende
   * des LETZTEN `nochmal` genau einmal (ein späterer Aufruf ersetzt einen früheren) — `true`. Steht keiner an (es war
   * Vesperas eigene Stimme, oder der Dreier-Modus ist aus): `false`, nichts gemerkt.
   */
  mikroNachVorlesen(nochmal: () => void): boolean {
    if (this.vorlesenOffen === 0) return false;
    this.nachVorlesen = nochmal;
    return true;
  }

  /**
   * Ein gemerktes übersprungenes Mikro verwerfen (Stopp, Sprechtaste, neuer Zug) — und eine offene Frage des Schmieds (oben,
   * 17.10.): Martin hat selbst gehandelt. `true`, wenn eines wartete.
   */
  verwirfMikroNachVorlesen(): boolean {
    const war = this.nachVorlesen !== null || this.frageNachher !== null;
    this.nachVorlesen = null;
    this.frageNachher = null;
    // Entscheidung Schmied (Prüfer, 20.10.2026): das gilt für JEDEN Stopp — Sprechtaste, neuer Strom, Sprung im Mini-Player, Stopp der
    // Pille. Die wartende Frage bleibt, wird danach vorgelesen und öffnet dann das Mikro (Wächter in app.ts: neuer Zug, „Fertig“, Stufe).
    // Nur ihr EIGENER Abbruch (vorgelesen(false)) oder „Fertig“ für den ganzen Zug (`fertig`) schließt sie.
    // 20.10.2026 (Martin 23:05): eine Frage, deren Beitrag noch VORGELESEN wird (steht in der Reihe oder spricht), entscheidet das Ende
    // genau dieses Vorlesens — gehört: Mikro auf, abgebrochen/nicht gehört: zu (`frageNachVorlesen`). Der Stopp einer ANDEREN
    // Wiedergabe (Knopf, Sprung, „Fertig“ nur für den Knopf) verwarf sie sonst, bevor Martin sie überhaupt gehört hatte.
    if (this.frage?.vorlesen && this.vorlesenOffen > 0) return war;
    return this.verwirfFrage() || war;
  }

  /**
   * Ein Zug Vesperas ist zu Ende (`zug`, app.ts `voice-v8:tts-audio-end` mit fertigem Zug). Hielt ein Beitrag an sie das Mikro
   * zu und ist das nicht der Zug, der schon fertig war, als er kam, ist das ihre Antwort: der Halt endet, das alte Warten und
   * ein gemerktes Mikro verfallen OHNE Öffnen — über das Mikro entscheidet jetzt ihre Antwort. `true`, wenn ein Halt endete.
   */
  vesperaAntwortet(zug: number): boolean {
    if (!this.halt || zug === this.halt.alterZug) return false;
    this.beendeHalt();
    this.nachVorlesen = null;
    this.abbrechen();
    return true;
  }

  /** Die Frist lief während des Vorlesens ab, das Vorlesen ist zu Ende: jetzt dieselbe Prüfung wie beim Fristablauf. */
  private fristNachVorlesen(): void {
    this.fristAbgelaufen = false;
    this.fristUm();
  }

  /**
   * Ein Stopp oder die Sprechtaste (stopCurrentTts): ein über die Frist hinaus verlängertes Warten endet ohne Öffnen — Martin
   * hat selbst gehandelt. `true`, wenn eines lief. Ein Warten innerhalb der Frist bleibt unberührt (altes Verhalten).
   */
  verwirfVerlaengerung(): boolean {
    if (!this.oeffne || !this.verlaengert) return false;
    this.abbrechen();
    return true;
  }

  private starteHalt(): void {
    const h = this.halt;
    if (!h) return;
    if (h.frist !== null) this.uhr.clearTimeout(h.frist);
    h.frist = this.uhr.setTimeout(() => {
      if (this.halt !== h) return;
      // Vespera hat nicht geantwortet (Fehler, Abbruch, kein Zug): jetzt öffnet, was ohne Halt geöffnet hätte.
      this.halt = null;
      if (this.oeffne) {
        if (this.vorlesenOffen === 0) this.loese("vespera-schweigt");
        else this.fristAbgelaufen = true;
        return;
      }
      if (this.vorlesenOffen > 0) return; // ein gemerktes Mikro löst das Ende des letzten Vorlesens ein
      const nach = this.nachVorlesen;
      this.nachVorlesen = null;
      nach?.();
    }, this.haltMs);
  }

  private beendeHalt(): void {
    if (this.halt?.frist != null) this.uhr.clearTimeout(this.halt.frist);
    this.halt = null;
  }

  /**
   * 17.10.2026 (Martin, 07:28–07:30): die Antwort des Schmieds kann auf DIESER Seite nicht gesprochen werden — ein anderes
   * Gerät oder eine andere Seite ist vorn (seiten-abgleich.ts „Geparkt“). Dann darf das Mikro hier nicht offen auf sie warten
   * und schon gar nicht danach von selbst aufgehen (`weil=verworfen` ging um 07:29:37 auf der hinteren Seite auf). Das Warten
   * endet OHNE Öffnen, ein gemerktes übersprungenes Mikro verfällt, ein Beitrag vor dem Warten öffnet später nichts (wie
   * „nur zur Info“). Das Zählen des Vorlesens läuft weiter; ein Halt an Vespera bleibt. `true`, wenn etwas wartete.
   */
  nichtVorn(): boolean {
    const war = this.oeffne !== null || this.nachVorlesen !== null || this.frage !== null;
    this.nachVorlesen = null;
    if (this.vorab) this.vorab = { ...this.vorab, info: true };
    this.abbrechen();
    return war;
  }

  /**
   * 17.10.2026 (Martin: „Fertig“, lib/fertig.ts): die Antwort ist abgeschlossen. Wie `nichtVorn` — das Warten endet OHNE
   * Öffnen, ein gemerktes übersprungenes Mikro verfällt, ein Beitrag vor dem Warten öffnet später nichts — und dazu endet
   * ein Halt an Vespera (seine Obergrenze öffnete sonst „vespera-schweigt“). Das Zählen des Vorlesens läuft weiter.
   * `true`, wenn etwas wartete oder hielt.
   */
  fertig(): boolean {
    const hielt = this.halt !== null;
    this.beendeHalt();
    return this.nichtVorn() || hielt;
  }

  /** Warten beenden, ohne zu öffnen — auch eine offene Frage des Schmieds (oben, 17.10.). Das Zählen des Vorlesens läuft weiter. */
  abbrechen(): void {
    this.verwirfFrage();
    this.warteAbbrechen();
  }

  /** Das Warten auf den Schmied beenden — eine offene Frage an Martin bleibt unberührt (Info, 19.10.2026). */
  private warteAbbrechen(): void {
    if (this.frist !== null) this.uhr.clearTimeout(this.frist);
    this.frist = null;
    this.oeffne = null;
    this.vesperaFrage = false;
    this.gezaehlt = false;
    this.fristAbgelaufen = false;
    this.beendeVerlaengerung();
  }

  private loese(weil: SchmiedOeffnetWeil): void {
    const fn = this.oeffne;
    this.abbrechen();
    fn?.(weil);
  }
}

/**
 * 17.10.2026 (Prüfauflage 1): das Zurückhalten eines Beitrags (seiten-abgleich.ts „Geparkt“) ist zu Ende. Nur wenn er HIER
 * nicht mehr gesprochen wird — eine andere Seite hat ihn gesprochen (`anderswo`) oder die Frist ist um (`frist`) —, endet das
 * Warten auf den Schmied ZU (`nichtVorn`). Wird diese Seite vorn (`vorn`), spricht sie ihn, und danach gilt Martins Regel vom
 * 16.10. wie immer („Frage → Mikro auf“ am bedienten Gerät). `true`, wenn das Warten so endete.
 */
export function nachZurueckhalten(w: SchmiedWarten, ergebnis: string | undefined): boolean {
  if (ergebnis !== "anderswo" && ergebnis !== "frist") return false;
  w.nichtVorn();
  return true;
}

/** Das Ereignis, wenn MARTIN den Schmied angesprochen hat (der Server meldet `schmied`, Vespera antwortet nicht). */
export const SCHMIED_ANGESPROCHEN = "voice-v8:schmied-angesprochen";

/** Was das Ereignis mitträgt: `abschied` — Martin hat ihn verabschiedet (server/dreier-modus.ts), das Mikro wartet nicht auf ihn. */
export interface SchmiedAngesprochenDetail {
  abschied: boolean;
}

/**
 * Aus dem Strom (lib/chat-http.ts, lib/ptt.ts): Martin hat den Schmied angesprochen — app.ts lässt das Mikro auf ihn warten.
 * `daten` ist der rohe Inhalt des Ereignisses `schmied`; nur ein ausdrückliches `abschied: true` zählt als Abschied.
 */
export function meldeSchmiedAngesprochen(daten?: unknown): void {
  const detail: SchmiedAngesprochenDetail = { abschied: (daten as { abschied?: unknown } | null | undefined)?.abschied === true };
  try {
    window.dispatchEvent(new CustomEvent<SchmiedAngesprochenDetail>(SCHMIED_ANGESPROCHEN, { detail }));
  } catch {
    /* kein window (Tests) */
  }
}
